import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BYPASS_INTERCEPTOR } from '../services/login.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { NgZone } from '@angular/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private redirectingToLogin = false;

  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private ngZone: NgZone,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = request.url || '';

    // Skip local assets and external URLs
    if (
      url.startsWith('/assets/') ||
      url.includes('assets/') ||
      url.startsWith('assets/') ||
      url.startsWith('http://localhost:4200/assets')
    ) {
      return next.handle(request);
    }

    if (request.context.get(BYPASS_INTERCEPTOR)) {
      return next.handle(request);
    }

    const token: string | null = sessionStorage.getItem('access_token');
    const activeClinicId: string | null = localStorage.getItem('activeClinicId');

    const headers: Record<string, string> = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    if (activeClinicId) {
      headers['X-Clinic-Id'] = activeClinicId;
    }

    if (Object.keys(headers).length > 0) {
      request = request.clone({ setHeaders: headers });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle 401 Unauthorized - Session expired or invalid token
        if (error.status === 401 && !this.redirectingToLogin) {
          this.redirectingToLogin = true;
          console.warn(
            '[AuthInterceptor] Received 401 Unauthorized - Session expired or invalid token',
          );

          // Clear all stored credentials and context
          sessionStorage.clear();
          localStorage.clear();

          // Fetch errors can arrive outside Angular's zone; run navigation inside it.
          this.ngZone.run(() => {
            void this.router.navigateByUrl('/login', { replaceUrl: true });
          });

          try {
            this.notificationService.error('Your session has expired. Please log in again.');
          } catch {
            // A notification failure must not prevent the expired-session redirect.
          }
        }
        return throwError(() => error);
      }),
    );
  }
}
